
import { db } from "../../services/firebase/Config";
import { SET_ACCESOS } from "./accesosTypes";

import {
  httpRequest,
  httpSuccess,
  httpFailure,
} from "../sesion/sesionActions";

import { fetchAccesosGeneral, fetchAccesosByEmpresa } from "../../services/firebase/accesos/index";
import { fetchMenus } from "../../services/firebase/menus";

import { obtenerPerfilPorId } from "../../services/firebase/perfiles";

export const setAccesos = (accesos) => {
  return {
    type: SET_ACCESOS,
    payload: accesos,
  };
};

export const getAccesosByEmpresa = (perfil, empresaId) => {

  return function (dispatch) {
    dispatch(httpRequest());
    fetchMenus()
      .then((accesos) => {
        accesos = accesos || [];
        return obtenerPerfilPorId(perfil).then((perfilData) => {
          if (perfilData && perfilData.length > 0) {
            accesos = accesos.filter((acceso) => perfilData.includes(acceso.id));
          }

          return accesos;
        });
      })
      .then((accesos) => {
        return obtenerPerfilPorId(perfil).then((perfilData) => {
          if (perfilData && perfilData.length > 0) {
            accesos = accesos.filter((acceso) => perfilData.includes(acceso.id));

          }
          return accesos;
        });

      })
      .then((accesos) => {

        dispatch(httpSuccess());
        dispatch(setAccesos(accesos));
      })
      .catch((err) => dispatch(httpFailure(err)));
  };
};

export const getAccesosGeneral = (perfil) => {
  return function (dispatch) {
    dispatch(httpRequest());
    fetchAccesosGeneral(perfil)
      .then((accesos) => {
        dispatch(httpSuccess());
        dispatch(setAccesos(accesos));
      })
      .catch((err) => dispatch(httpFailure(err)));
  };
};
